import { useEffect, useState } from 'react';

const links = [
  { href: '#home', label: '首页' },
  { href: '#ranking', label: '实时榜单' },
  { href: '#pk', label: '人气PK' },
  { href: '#shows', label: '参赛看点' },
  { href: '#guide', label: '打榜指南' },
  { href: '#faq', label: '常见答疑' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[70px]">
          <a href="#home" className="flex items-center gap-2 font-display">
            <span className="relative w-9 h-9 rounded-full bg-gradient-to-br from-melon-500 to-melon-700 flex items-center justify-center text-white text-lg">
              <i className="ri-vip-crown-fill"></i>
            </span>
            <span className={`font-display font-bold text-xl ${scrolled ? 'text-ink' : 'text-white'}`}>
              吃瓜大赛
            </span>
            <span className={`hidden sm:inline-block text-xs font-bold px-2 py-1 rounded-full ${scrolled ? 'bg-melon-100 text-melon-600' : 'bg-white/20 text-white'}`}>
              Season 2026
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                  scrolled ? 'text-ink/80 hover:text-melon-600 hover:bg-melon-50' : 'text-white/90 hover:text-white hover:bg-white/20'
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#ranking"
              className="inline-flex items-center gap-1.5 whitespace-nowrap px-5 py-2.5 text-sm font-semibold rounded-full bg-gradient-to-r from-melon-500 to-melon-600 text-white hover:from-melon-600 hover:to-melon-700 transition-all"
            >
              <i className="ri-fire-line"></i>立即打榜
            </a>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-2xl cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${open ? 'close' : 'menu'}-line ${scrolled ? 'text-ink' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur border-t border-melon-100 px-4 py-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block px-4 py-3 text-sm font-medium text-ink/80 hover:text-melon-600 rounded-lg cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#ranking"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 px-5 py-3 text-sm font-semibold rounded-full bg-gradient-to-r from-melon-500 to-melon-600 text-white"
          >
            <i className="ri-fire-line"></i>立即打榜
          </a>
        </div>
      )}
    </header>
  );
}